import styled from "@emotion/styled";

interface ArrowsStyledProps {
    color: string;
}

const shouldForwardProp = (prop: string): boolean => {
    switch (prop) {
        // Add any props here that should not be forwarded to the underlying DOM element.
        case "color":
            return false;
        default:
            return true;
    }
};

export const ArrowsStyled = styled("svg", { shouldForwardProp })<ArrowsStyledProps>`
    position: absolute;
    color: ${({ color }) => color};
`;
